import type { FC } from "react";
import { useContext } from "react";

import { PushBlock as PushBlockUI } from "@jti/ui/components/PushBlock";

import { GridContext } from "@/components/Grid/Grid";
import { usePageConfig } from "@/context/PageConfigContext";

import { mapPushBlockProps } from "./utils/mapPushBlockProps";

import type { pushBlockInputs } from "./PushBlock.builder";

export type PushBlockBuilderProps = BuilderComponentProps<typeof pushBlockInputs>;

export const PushBlock: FC<PushBlockBuilderProps> = ({
  desktopImage,
  mobileImage,
  alt,
  orientation,
  title,
  subtitle,
  description,
  cta,
  href,
  containedCTA,
  smallHeightOnMobile,
  trackingEvent,
  mobileOrientation,
  logo,
  blockContentProperties,
  secondButton,
  theme = "inherit",
  imageFit,
}) => {
  const { darkMode } = usePageConfig();

  const pushBlockUIProps = mapPushBlockProps({
    desktopImage,
    mobileImage,
    alt,
    orientation,
    title,
    subtitle,
    description,
    cta,
    href,
    containedCTA,
    smallHeightOnMobile,
    trackingEvent,
    mobileOrientation,
    logo,
    blockContentProperties,
    secondButton,
    theme,
    imageFit,
    darkMode,
  });

  const gridConfig = useContext(GridContext);

  return <PushBlockUI {...pushBlockUIProps} gridConfig={gridConfig} />;
};
